import React, { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const formatDate = (value) => value ? new Date(value).toLocaleString("ar-SA") : "لا يوجد دخول مسجل";

export default function CounselorLoginHistory() {
  const { user } = useAuth();
  const allowed = user?.role === "admin" && user?.can_evaluate_counselors;
  const [days, setDays] = useState("30");
  const [result, setResult] = useState({ counselors: [], entries: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!allowed) return;
    let active = true;
    setLoading(true);
    setError("");
    api.get("/counselors/login-history", { params: { days } }).then(({ data }) => {
      if (active) setResult(data);
    }).catch((failure) => {
      if (active) setError(formatErr(failure));
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [allowed, days]);
  if (!allowed) return <p role="alert">متابعة دخول المرشدين متاحة للمشرف الإرشادي المخوّل فقط.</p>;
  return (
    <section className="space-y-4 rounded-2xl border border-[#e6e2d8] bg-white p-5" data-testid="counselor-login-history">
      <h1 className="text-xl font-bold">متابعة دخول المرشدين للمنصة</h1>
      <p className="text-sm text-[#4A554E]">تسجيل دخول ناجح فقط؛ آخر دخول لا يعني أن المستخدم متصل الآن.</p>
      <label className="block text-sm">الفترة
        <select aria-label="الفترة" value={days} onChange={(event) => setDays(event.target.value)} className="ms-2 rounded-lg border p-2">
          <option value="7">آخر 7 أيام</option><option value="30">آخر 30 يوماً</option><option value="90">آخر 90 يوماً</option><option value="365">آخر سنة</option>
        </select>
      </label>
      {loading ? <p>جاري تحميل أوقات الدخول...</p> : error ? <p role="alert" className="text-red-700">{error}</p> : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full text-sm"><thead><tr><th className="p-2 text-start">المرشد</th><th className="p-2 text-start">المدرسة والقسم</th><th className="p-2 text-start">آخر دخول ناجح</th></tr></thead>
              <tbody>{result.counselors.map((counselor) => <tr key={counselor.id} className="border-t">
                <td className="p-2">{counselor.name}</td><td className="p-2">{counselor.school_name || counselor.school_key} — {counselor.gender === "female" ? "بنات" : "بنين"}</td><td className="p-2">{formatDate(counselor.last_login_at)}</td>
              </tr>)}</tbody>
            </table>
          </div>
          <h2 className="font-semibold">سجل الدخول خلال الفترة المحددة</h2>
          {result.entries.length ? result.entries.map((entry) => <p key={entry.id} className="border-t p-2 text-sm">{entry.name} — {formatDate(entry.logged_in_at)}</p>) : <p className="text-sm">لا توجد زيارات دخول مسجلة خلال الفترة المحددة.</p>}
        </>
      )}
    </section>
  );
}
